import { Container } from './Layout.styled';

const Layout = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Layout;
